import { render, staticRenderFns } from "./SalesSummary.vue?vue&type=template&id=137f7234"
import script from "./SalesSummary.vue?vue&type=script&lang=js"
export * from "./SalesSummary.vue?vue&type=script&lang=js"
import style0 from "./SalesSummary.vue?vue&type=style&index=0&id=137f7234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports